import React from 'react'
import styles from "../styles/Principal.module.css"

const Principals = () => {
  return (
    <div id='core' className={styles.principal_cont}>
        <h2>Key Operating Principles</h2>
        <div className={styles.principal_grid}>
            <div className={styles.principal_grid1}>
                <h3>1</h3>
                <h4>Collective Expertise</h4>
                <p>Leverage organizational knowledge rather than individual capabilities</p>
            </div>
            <div className={styles.principal_grid1}>
                <h3>2</h3>
                <h4>Collaborative Partnership</h4>
                <p>Work together with clearly defined roles and shared <br /> objectives</p>
            </div>
            <div className={styles.principal_grid1}>
                <h3>3</h3>
                <h4>Execution Excellence</h4>
                <p>Focus on practical implementation  and <br /> measurable results</p>
            </div>
        </div>
    </div>
  )
}

export default Principals